import { type ReactNode } from 'react';
import ErrorBoundary from '../shared/ErrorBoundary';
import { reportCrashToParent } from '../../hooks/useParentMessaging';
import { useAnnounceReadyToShow } from '../../hooks/useEmbeddedHost';
import { useTranslation } from '../../i18n/i18n';
import { abortVariantConfig } from '../../utils/abortVariants';
import EmbeddedCardLayout from './CardLayout';
import EmbeddedStatusBlock from './StatusBlock';

/** The technical error, as the init errors show it. */
function CrashScreen() {
  const { t } = useTranslation();
  const { titleKey, subtitleKey } = abortVariantConfig.serverError;
  // A crash before the flow was shown still shows.
  useAnnounceReadyToShow(true);

  return (
    <EmbeddedCardLayout>
      <EmbeddedStatusBlock
        visual="alert"
        title={t(titleKey)}
        sub={t(subtitleKey)}
      />
    </EmbeddedCardLayout>
  );
}

/**
 * EmbeddedCrashBoundary — A screen that crashes shows the error inside the
 * card or drawer, so the drawer can still be closed, and the page hears
 * `verid:error` once its origin is verified.
 */
export default function EmbeddedCrashBoundary({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <ErrorBoundary fallback={<CrashScreen />} onError={reportCrashToParent}>
      {children}
    </ErrorBoundary>
  );
}
